import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
} from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormComponent } from '../form.components';

export type RadioCardOption = {
  label?: string;
  title?: string;
  description?: string;
  desc?: string;
  value: any;
  variant?: 'primary' | 'danger' | 'warning' | 'cancel' | string;
  disabled?: boolean;
  icon?: string;
  badge?: string;
  [key: string]: any;
};

@Component({
  selector: 'hospitality-bot-radio-card-group',
  templateUrl: './radio-card-group.component.html',
  styleUrls: ['./radio-card-group.component.scss'],
})
export class RadioCardGroupComponent extends FormComponent implements OnInit {
  private _options: RadioCardOption[] = [];

  @Input()
  set options(input: any) {
    this._options = Array.isArray(input) ? input : [];
  }

  get options(): any {
    return this._options;
  }

  @Input() label: string;
  @Input() description: string;
  @Input() value: any;
  @Input() name: string = 'radioCardGroup';
  @Input() layout: 'vertical' | 'horizontal' = 'vertical';
  @Input() gap: string = '10px';
  @Input() customWrapperClass: string = '';
  @Input() disabled: boolean = false;
  @Input() isRequired: boolean = false;

  @Output() valueChange = new EventEmitter<any>();
  @Output() onChange = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<RadioCardOption>();

  constructor(@Optional() public controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void {
    if (this.controlName && this.controlContainer?.control) {
      this.initInputControl();
      const ctrl = this.inputControl || this.controlContainer.control.get(this.controlName);
      if (ctrl) {
        this.value = ctrl.value;
        ctrl.valueChanges?.subscribe((val: any) => {
          this.value = val;
        });
      }
    }
  }

  isSelected(option: RadioCardOption): boolean {
    let currentValue = this.value;
    if (this.controlName && this.controlContainer?.control) {
      const ctrl = this.controlContainer.control.get(this.controlName);
      if (ctrl) {
        currentValue = ctrl.value;
      }
    } else if (this.inputControl) {
      currentValue = this.inputControl.value;
    }
    return currentValue === option.value;
  }

  selectOption(option: RadioCardOption): void {
    if (this.disabled || this.isDisabled || option.disabled) {
      return;
    }
    this.value = option.value;
    const ctrl =
      this.inputControl ||
      (this.controlName && this.controlContainer?.control?.get(this.controlName));
    if (ctrl) {
      ctrl.setValue(option.value);
      ctrl.markAsDirty();
      ctrl.markAsTouched();
    }
    this.valueChange.emit(option.value);
    this.onChange.emit(option.value);
    this.onSelect.emit(option);
  }
}
